module.exports = __webpack_public_path__ + "static/why-us-19961b49035ec687ce475d82527c5095.png";